// TAŞI — "SON HEDEFLER" belleği. YALNIZCA tarayıcı deposunda tutulur,
// sunucuya gönderilmez. Anahtar kullanıcıya özeldir; aynı tarayıcıda başka
// kullanıcı giriş yaparsa başkasının geçmişini GÖRMEZ.
const ONEK = "sertex_move_recent_v1";
const MAKS = 5;

const anahtar = (userId) => `${ONEK}:${userId || "anon"}`;

export function sonHedefleriOku(userId) {
  try {
    const raw = localStorage.getItem(anahtar(userId));
    if (!raw) return [];
    const arr = JSON.parse(raw);
    return Array.isArray(arr) ? arr.filter((x) => typeof x === "string").slice(0, MAKS) : [];
  } catch {
    return [];
  }
}

export function sonHedefEkle(userId, targetId) {
  if (!targetId) return;
  try {
    const mevcut = sonHedefleriOku(userId).filter((x) => x !== targetId);
    localStorage.setItem(anahtar(userId), JSON.stringify([targetId, ...mevcut].slice(0, MAKS)));
  } catch (e) {
    console.warn("[moveRecentTargets] yazılamadı:", e);
  }
}

export function sonHedefleriYaz(userId, ids) {
  try {
    localStorage.setItem(anahtar(userId), JSON.stringify((ids || []).slice(0, MAKS)));
  } catch (e) {
    console.warn("[moveRecentTargets] yazılamadı:", e);
  }
}
